import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EParentRegionActionType {
  SetParentRegionId = 'ParentRegion/SetParentRegionId',
}

export type TSetParentRegionAction = ITypedReduxAction<EParentRegionActionType.SetParentRegionId, number>;

export type TParentRegionActions = TSetParentRegionAction;
